export enum PublicOrderListItemAction {
  Preview,
  EditShippingAddresses,
  More,
}
